<template>
  <div class="upload-wrapper">
    <div class="content">
      <template v-if="!inAnswerUpload">

        <div class="row">
          <div class="col-xs-6 type_name_slug">
            <label class="control-label" for="type_name_slug">What type of document?</label>
            <v-select
                class="style-chooser"
                id="type_name_slug"
                v-model="currentTypeNameSlug"
                label="type_name"
                :reduce="companyNameData => companyNameData.type_name_slug"
                :options="typeNameSlugDataOptions"
                taggable
                placeholder="What type of document?">
            </v-select>
            <input type="hidden" v-model="currentTypeNameSlug" name="type_name_slug" />
          </div>

          <div class="col-xs-12">
            <template v-if="canUpload">
              <div class="dropzone-wrapper" :class="{'dropzone-wrapper-answer': inAnswerUpload}" v-if="currentTypeNameSlug">
                <vue-dropzone
                    ref="myVueDropzone"
                    id="dropzone"
                    :options="dropzoneOptions"
                    :useCustomSlot="true"
                    v-on:vdropzone-file-added="uploadFile"
                >
                  <div class="dropzone-custom-content">
                    <i class="fal fa-file-plus"></i>
                    Drag & Drop or Click to upload
                  </div>
                  <div class="subtitle file-error" v-if="errorMessage">{{ this.errorMessage }}</div>
                </vue-dropzone>
              </div>
            </template>
            <template v-else>
              <div class="text-center">
                <template v-if="canUpdateCountDocument">
                  <p><b>You have reached your document audit scan limit</b></p>
                  <a href="/account/upgrade?scan_only=true" target="_blank" class="btn btn-primary submit">Upgrade to add more document audit scans</a>
                </template>
                <template v-else>
                  <p><b>You have document audit scan limit</b></p>
                  <a href="/account/upgrade" target="_blank" class="btn btn-primary submit">Upgrade plan</a>
                </template>
              </div>
            </template>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="dropzone-wrapper" :class="{'dropzone-wrapper-answer': inAnswerUpload}">
          <vue-dropzone
              ref="myVueDropzone"
              id="dropzone"
              :options="dropzoneOptions"
              :useCustomSlot="true"
              v-on:vdropzone-file-added="uploadFile"
          >
            <div class="dropzone-custom-content">
              <i class="fal fa-file-plus"></i>
              Drag & Drop or Click to upload
            </div>
            <div class="subtitle file-error" v-if="errorMessage">{{ this.errorMessage }}</div>
          </vue-dropzone>
        </div>
      </template>

      <div class="documents-table-wrapper" :class="{'document-answer-table-container': inAnswerUpload}" v-if="list && list.length >0">
        <table class="table table-striped table-hover documents-table">

          <thead>
          <tr>
            <th class="col-3">
              Name
            </th>
            <th class="col-3">
              <template v-if="this.inAnswerUpload">
                Uploaded
              </template>
              <template v-else>
                Date Uploaded
              </template>
            </th>
            <th class="col-4">
              Uploaded By
            </th>
            <th class="col-2">
              Status
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="document in list" :key="document.id">
            <td class="col-3 document_name_col">
              {{ document['name'] }}
            </td>
            <td class="col-3">
              <div>{{ formattedDate(document.updated_at).days }} {{ formattedDate(document.updated_at).hours }}</div>
            </td>
            <td class="col-4 business-function">
              <span class="bold">{{ document['user_name']}}</span>
              <!--              <span class="bold">{{ document['business_function'].parent_title }} ></span>-->
              <!--              <span>{{ document['business_function'].title }} </span>-->
            </td>

            <td class="col-2">
              <div class="status">
                <div class="status-text bold">
                  <div v-if="document.status === statuses.PROCESSED.name">

                    <template v-if="this.inAnswerUpload">
                      <a class="document-link" :href="'/documents/download/' + document.id">
                        Download <i class="fal fa-file-download"></i>
                      </a>
                      <br>
                      <a type="button" class="document-link" v-on:click="deleteDocument(document.id)">
                        Delete <i class="fa fa-trash"></i>
                      </a>
                    </template>

                    <template v-else>
                      <p v-if="document.type_name_slug === 'suitability_report_audit' ||
                        document.type_name_slug === 'pension_report_audit' ||
                        document.type_name_slug === 'client_agreement_document_audit' ||
                        document.type_name_slug === 'best_execution_policy_audit' ||
                        document.type_name_slug === 'business_continuity_policy_audit' ||
                        document.type_name_slug === 'anti_money_laundering_audit' ||
                        document.type_name_slug === 'conflict_of_interest_policy_audit' ||
                        document.type_name_slug === 'information_technology_data_security_document_audit' ||
                        document.type_name_slug === 'financial_promotions_policy_audit' ||
                        document.type_name_slug === 'financial_promotions_mortgages_policy_audit' ||
                        document.type_name_slug === 'financial_promotions_general_insurance_policy_audit' ||
                        document.type_name_slug === 'vulnerable_customer_policy_audit' ||
                        document.type_name_slug === 'anti_bribery_policy_audit' ||
                        document.type_name_slug === 'whistleblowing_policy_audit' ||
                        document.type_name_slug === 'centralised_retirement_proposition_document_audit' ||
                        document.type_name_slug === 'prod_policy_document' ||
                        document.type_name_slug === 'cip_policy_document' ||
                        document.type_name_slug === 'fund_switch_suitability_audit' ||
                        document.type_name_slug === 'annual_review_audit' ||
                        document.type_name_slug === 'isa_top_up_audit' ||
                        document.type_name_slug === 'pension_withdrawal_audit' ||
                        document.type_name_slug === 'subsequent_pension_withdrawal_audit' ||
                        document.type_name_slug === 'mortgage_advice_audit'">
                        <a class="document-link" :href="'/documents/view/' + document.id">
                          <b>
                            <i class="fa fa-eye"></i>
                            View Report
                          </b>
                        </a>
                      </p>
                    </template>

                  </div>
                  <div v-else-if="document.status === statuses.FAILED.name" class="file-error">
                    {{ document['status'] }}
                  </div>
                  <div class="status-item" v-else>
                    <div class="loader">
                      <div class="bar"></div>
                    </div>
                    {{ document['status'] }}...
                  </div>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import statuses from './statuses.js'
import vue2Dropzone from "dropzone-vue3"

export default {
  props: ['withList', 'answer', 'title', 'abilityUpload', 'abilityUpdateCountDocument'],
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      statuses: statuses,
      dropzoneOptions: {
        autoProcessQueue: false,
        url: "documents/save",
        addRemoveLinks: false,
        maxFiles: 1,
        progress: false
      },
      fileName: '',
      errorMessage: null,
      list: [],
      currentTypeNameSlug: null,
      typeNameSlugDataOptions: [],
    }
  },
  created() {
    if (this.withList) {
      this.getDocumentList()
    }
    this.getDocumentTypes();
  },
  computed: {
    inAnswerUpload() {
      return typeof this.answer.answer_id === 'number' && Number.isInteger(this.answer.answer_id);
    },
    canUpload() {
      return this.abilityUpload !== 'disabled';
    },
    canUpdateCountDocument() {
      return this.abilityUpdateCountDocument !== 'disabled';
    }
  },
  watch: {
    currentTypeNameSlug: {
      handler(newValue, oldValue) {
        this.handleFilterChange();
      },
      deep: true
    },
  },
  methods: {
    getStatus(value) {
      return this.statuses.map(function (item) {
        console.log(item)
      })
    },
    formattedDate: function (time) {
      return {
        'days': moment(time).format('DD MMM YYYY'),
        'hours': moment(time).format('h:mma')
      }
    },
    getDocumentTypes() {
      axios.get('/monitor/document-types')
          .then(response => {
            this.typeNameSlugDataOptions = response.data;
          })
          .catch(error => {
            console.log(error.response?.data?.message || 'Unknown error');
          });
    },
    getDocumentList() {
      let path = '/monitor/documents-list';
      let config = this.currentTypeNameSlug ? {params: {'selected_filter': this.currentTypeNameSlug}} : null;

      if (this.inAnswerUpload) {
        path = `/documents/answer/list/${this.answer.answer_id}`;
        config = null;
      }
      axios.get(path, config)
          .then(res => {
            this.list = res.data.data
          })
          .catch(err => {
            console.error(err)
          })
    },
    getDocument(id) {
      axios.get('/documents/' + id)
          .then(res => {
            if (!this.withList) {
              this.list = [res.data.data]
            } else {
              this.list.shift()
              this.list.unshift(res.data.data)
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    uploadFile(file) {
      this.errorMessage = null
      let ext = file.name.split('.')[1]

      if (ext !== 'doc' && ext !== 'docx' && ext !== 'pdf' && ext !== 'xls' && ext !== 'xlsx') {
        this.errorMessage = "File format should be just '.doc' or '.docx' or '.pdf' or '.xls' or '.xlsx' please try again"
        this.$refs.myVueDropzone.removeAllFiles()
        return false;
      }

      let fileName = Math.random().toString().slice(2) + '.' + ext
      axios.post('/documents/save',
          {
            'filename': fileName,
            original_name: file.name.split('.')[0],
            answerId: this.answer.answer_id,
            'type_name_slug': this.currentTypeNameSlug
          }
      ).then(data => {
          let document = data.data.data;
          this.list = [document, ...this.list];
          this.runUpload(file, data.data.uri, document);
      })
    },
    runUpload(file, url, document) {
      axios.put(url, file)
          .then(data => {
            if (this.inAnswerUpload) {
              this.changeStatus(statuses.PROCESSED.value, document);
              this.checkDocument(document);
            } else {
              this.changeStatus(statuses.UPLOADED.value, document)
              this.verify(file, document)
            }
          })
          .catch(err => {
            this.uploading = false;
            console.error(err)
          })
    },
    verify(file, document) {
      axios.post('/documents/' + document.id + '/verify')
          .then(response => {
            if (response.status === 200) {
              this.changeStatus(statuses.PROCESSING.value, document)
              this.checkDocument(document)
            }
          }).catch(err => {
        console.error('azureRequest', err)
      })
    },
    checkDocument(document) {
      let evtSource = new EventSource('/documents/' + document.id + '/check')
      evtSource.addEventListener(
          'message',
          event => {
            if (event.data) {
              let response = JSON.parse(event.data)
              evtSource.close()
              if (response.document) {
                let prepared_document = JSON.parse(event.data)
                document = prepared_document.document[0]
              } else if (response.errors) {
                document.status = "Failed"
              }
              this.getDocument(document.id)
              this.$refs.myVueDropzone.removeAllFiles()
              if (!this.inAnswerUpload) {
                this.runAuditProcess(document.id, document.type_name_slug);
              }
            }
          }, false)

      evtSource.addEventListener('error', event => {
        if (event.readyState == EventSource.CLOSED) {
        }
      }, false)
    },
    changeStatus(status, document) {
      axios.post('/documents/' + document.id + '/change-status', {'status': status})
          .then(data => {
            document.status = data.data
          })
          .catch(err => {
            console.error('error', err)
          });
    },
    runAuditProcess(id, type) {
      axios.get(
          `/monitor/new-audit-data/${id}`
      ).then(res => {
        window.location.href = `/documents/view/${id}`;
      }).catch(err => {
        console.error(err)
      })
    },
    deleteDocument(id) {
      if(confirm("Do you really want to delete?")) {
        axios.delete(`/documents/delete/${id}`).then((res) => {
          this.getDocumentList();
        }).catch((error) => {
          console.log('error', error)
        })
      }
    },
    handleFilterChange() {
      console.log('Selected Filter:', this.selectedFilter);
      this.getDocumentList();
    },
  }
}
</script>
<style scoped lang="less">

.bold {
  font-weight: bold;
}

.content {
  height: 100%;
  background-color: white;
  border-radius: 10px;
  margin-bottom: 30px;
  font-size: 14px;
  font-family: "MuseoSansRounded-300", 'Open Sans', sans-serif;

  .header-logo{
    float: left;
    max-width: 50%;
    margin-bottom: 25px;

    margin-left: 30px;

    img{
      max-width: 40%;
    }
  }

  .document-header {
    margin-left: 30px;
    margin-bottom: 25px;
  }

  .document-header-text{
    clear: both;
    margin-bottom: 25px;
    margin-left: 30px;
  }

  .template-download{
    float:right;
    margin-right: 30px;
    font-size: 1.2em;
  }

  .fa-file-plus {
    margin-right: 10px;
    color: black;
  }

  .dropzone-wrapper {
    border: 10px solid #67C6B0;
    border-radius: 10px;
    background-color: #67C6B0;
    margin: 0px 30px;
    display: flex;

    #dropzone {
      min-height: 50px;
      border: 0px solid #67C6B0;
      border-radius: 10px;
      padding: 0;
      color: black;
      font-weight: 300;
      width: 100%;
      margin: 0;

      .dropzone-custom-content .subtitle {
        font-weight: bold;
      }
    }
  }

  .documents-table-wrapper {
    .documents-table {
      th, tr td {
        padding: 25px 15px;
        font-size: 14px;
      }
    }
  }

  .document-link {
    color: black;
    text-decoration: none;
    cursor: pointer;

    .fa-file-download {
      font-size: 20px;
      margin-left: 5px;
    }
  }

  .fa-comments-alt {
    font-size: 22px;
    color: gray;
  }

  .col-1 {
    width: 8.6%;
  }

  .col-2 {
    width: 16.6%;
  }

  .col-3 {
    width: 25%;
  }

  .col-4 {
    width: 33%;
  }
}

@keyframes loader-animation {
  0% {
    left: 0;
  }
  100% {
    left: 100%;
  }
}

.loader {
  height: 11px;
  width: 75%;
  overflow: hidden;
  background-color: #bfbfbf;
}

.loader .bar {
  position: relative;
  height: 10px;
  width: 15%;
  background-color: #67C6B0;
  animation-name: loader-animation;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.document-hours {
  font-size: 12px;
}

.file-error {
  color: red;
}

.loader {
  height: 11px;
  width: 75%;
  overflow: hidden;
  background-color: #bfbfbf;

}

.loader .bar {
  position: relative;
  height: 10px;
  width: 15%;
  background-color: black;
  animation-name: loader-animation;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
</style>

<style scoped>

.dz-progress {
  display: none;
}

.document .global-score {
  min-height: 500px;
  padding: 0 50px;
}

.document {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #F1F1F1;
}

.document .documents-table-wrapper {
  margin: 25px 30px;
}

.document-wrapper .vue-dropzone {
  margin: 0px 30px;
}

/*answer documents*/
.document-answer-table-container {
  max-height: 240px;
  overflow-y: auto;
}
.content .dropzone-wrapper.dropzone-wrapper-answer{
  background-color: white;
  transform: scale(0.85);
}
.document_name_col {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 70px;
}
.type_name_slug {
  margin-bottom: 15px;
}
</style>
<style scoped>
>>> {
  --vs-controls-color: #67C6B0;
  --vs-border-color: #67C6B0;

  --vs-dropdown-option--active-bg: #67C6B0;
  --vs-dropdown-option--active-color: #ffffff;
}
</style>